<template>
  <div v-if="membre && nbHeuresEffectives > 0 && nombreHeuresPrevues > 0" class="planning-header-semaine-temps-membre">
    <v-tooltip color="black">
      <template v-slot:activator="{ on, attrs }">
        <v-chip outlined :color="chipColor" v-bind="attrs" v-on="on">
          <v-icon left :color="membre.couleur">mdi-circle</v-icon>
          <span v-if="montrerHeuresTravailles" class="text--black">
            {{ nbHeuresEffectives }}<span v-if="membre.heuresHebdo > 0 && !compact"> / {{ membre.heuresHebdo }}h</span>
          </span>
          <span v-else class="text--black"
            >{{ nombreHeuresPrevues
            }}<span v-if="membre.heuresHebdo > 0 && !compact"> / {{ membre.heuresHebdo }}h</span></span
          >
        </v-chip>
      </template>
      <div>
        <label class="text-body-2">Heures de {{ membre.employe.utilisateur.nomComplet }} cette semaine : </label>
        <ul>
          <li :style="bulletPointStyleHeuresPrevues">
            Heures à comptabiliser : {{ nombreHeuresPrevues }}<small> (congés compris)</small>
          </li>
          <li :style="bulletPointStyleHeurestravailles">Heures effectives : {{ nbHeuresEffectives }}</li>
          <li>
            Heures prévues par le contrat :
            <span v-if="membre.heuresHebdo > 0">{{ membre.heuresHebdo }}</span>
            <span v-else>Indisponible</span>
          </li>
        </ul>
      </div>
    </v-tooltip>
  </div>
</template>

<script>
import moment from 'moment/moment'
const NB_MAX_HEURES_HEBDO = 48
export default {
  name: 'planning-header-semaine-membre',
  components: {},
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    creneauxMembre: {
      type: Array,
      required: true,
    },
    membre: {
      type: Object,
      required: true,
    },
    montrerHeuresTravailles: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    employe() {
      return this.membre.employe
    },
    chipColor() {
      if (this.membre.heuresHebdo > NB_MAX_HEURES_HEBDO) return 'red'

      if (this.membre.heuresHebdo < this.nbHeuresEffectives) return 'orange'
      return 'grey'
    },
    bulletPointStyleHeuresPrevues() {
      return !this.montrerHeuresTravailles ? "list-style-type: '⦿ ';" : "list-style-type: '• ';"
    },
    bulletPointStyleHeurestravailles() {
      return this.montrerHeuresTravailles ? "list-style-type: '⦿ ';" : "list-style-type: '• ';"
    },
    nbHeuresEffectives() {
      let result =
        this.creneauxMembre
          .filter(
            (c) =>
              [
                'CreneauDeTravail',
                'CreneauHeuresSupplementaires',
                'CreneauDeRemplacement',
                'CreneauDeFormation',
              ].includes(c.type) && !this.estIndispoADate(c.date)
          )
          .map((c) => c.heureFin.valeur - c.heureDebut.valeur)
          .reduce((a, b) => a + b, 0) / 60

      return Math.round(result * 100) / 100
    },
    nombreHeuresPrevues() {
      let result =
        this.creneauxMembre
          .filter((c) =>
            [
              'CreneauDeTravail',
              'CreneauHeuresSupplementaires',
              'CreneauDeRemplacement',
              'CreneauDeFormation',
            ].includes(c.type)
          )
          .map((c) => c.heureFin.valeur - c.heureDebut.valeur)
          .reduce((a, b) => a + b, 0) / 60

      return Math.round(result * 100) / 100
    },
  },
  methods: {
    estIndispoADate(date) {
      return this.employe.indisponibilites.some((i) => {
        return (
          moment()
            .isoWeekYear(i.semaine.annee)
            .isoWeek(i.semaine.semaine)
            .day(i.jour.jourId - 1)
            .format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD')
        )
      })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.planning-header-semaine-temps-membre {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.v-avatar {
  margin-right: 2px;
}
</style>
